<template>
  <div
    :class="['slide']"
    :style="{ background: gradient }"
  >
    <div
      :class="$style.image"
      :style="{ backgroundImage: `url(${imageUrl})` }"
    />

    <div :class="$style['media-wrapper']">
      <div :class="$style.promo">
        {{ t(`${props.info.promo}`) }}
      </div>

      <div :class="$style.title">
        {{ t(`${props.info.title}`) }}
      </div>

      <div :class="$style.text">
        <p v-html="t(`${props.info.text}`)" />
      </div>

      <Controller :to="props.info.link">
        {{ t(`${props.info.btn}`) }}
      </Controller>
    </div>
  </div>
</template>

<script lang="ts" setup>
import Controller from "~/components/Home/Intro/Banner/Controller.vue";
const { t } = useI18n();
const props = defineProps<{
  info: {
    promo: string;
    title: string;
    text: string;
    btn: string;
    link: string;
    gradientDesktop: string;
    gradientTablet: string;
    gradientMobile: string;
    imgDesk: string;
    imgTablet: string;
    imgMobile: string;
  };
}>();

const windowWidth = ref(window.innerWidth);
const imageUrl = ref("");
const gradient = ref("");

const updateMedia = () => {
  windowWidth.value = window.innerWidth;
  if (windowWidth.value <= 1000 && windowWidth.value >= 801) {
    imageUrl.value = props.info.imgTablet;
    gradient.value = props.info.gradientTablet;
  } else if (windowWidth.value <= 800) {
    imageUrl.value = props.info.imgMobile;
    gradient.value = props.info.gradientMobile;
  } else {
    imageUrl.value = props.info.imgDesk;
    gradient.value = props.info.gradientDesktop;
  }
};

onMounted(() => {
  updateMedia();
  window.addEventListener("resize", updateMedia);
});

onUnmounted(() => {
  window.removeEventListener("resize", updateMedia);
});
</script>

<style lang="scss" module>
.media-wrapper {
  @media screen and (max-width: 800px) {
    position: absolute;
    align-items: center;
    display: flex;
    flex-direction: column;
    top: 50%;
    width: 100%;
    .promo {
      font-size: 12px;
      margin-bottom: 0;
    }
    .title {
      margin-bottom: 6px;
    }
    .text {
      margin-top: 0;
      margin-bottom: 40px;
      max-width: 347px;
      text-align: center;
    }
  }
}
.promo {
  margin-bottom: 28px;
  color: var(--general-transparent-light-50);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: -0.12px;
  text-transform: uppercase;
  @media screen and (max-width: 1000px) {
    margin-bottom: 10px;
  }
}

.title {
  position: relative;
  z-index: 1;
  font-size: 40px;
  font-weight: 700 !important;
  line-height: 45px;
  color: var(--general-white);
  @media screen and (max-width: 1000px) {
    font-size: 28px;
  }
  @media screen and (max-width: 375px) {
    font-size: 20px;
  }
}

.text {
  position: relative;
  z-index: 1;
  margin-top: 16px;
  max-width: 332px;
  p {
    line-height: 140%;
    font-size: 14px;
    letter-spacing: -0.14px;
    color: var(--general-transparent-light-70);
  }
  @media screen and (max-width: 375px) {
    width: 320px;
  }
}

.image {
  position: absolute;
  top: 0;
  background-size: cover;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center;

  @media screen and (max-width: 1500px) {
    background-position: 70%;
  }
  @media screen and (max-width: 1000px) {
    background-position: 90%;
    background-size: contain;
    border-radius: 20px;
  }
  @media screen and (max-width: 850px) {
    background-size: cover;
    left: 0;
  }
  @media screen and (max-width: 800px) {
    border-radius: 26px;
  }
  @media screen and (max-width: 420px) {
    position: relative;
    // background-position: 110%;
    background-position: center;
  }
}
</style>
